var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('widget',{attrs:{"color":"primary","title":"SMS Transaction Parser"}},[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('parsing-rules')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }